<template>
  <div>
    <div class="flex flex_justify_end">
      <a @click="uploadFile" class="button is-info">Upload File</a>
    </div>
    <div>
      <div v-if="is_loading" class="loading"></div>
      <single-file ref="file" v-for="(file) in files" @input="setFileChecked(file.name, $event)" :file="file"
                  :resource_type="payload.resource_type" :resource_id="payload.resource_id" :is_checked="selected_files[file.name].is_checked" :is_show_checkbox="show_checkboxes" :key="file.name" @refresh="init">
      </single-file>
    </div>
    <div>
      <p v-for="non_unique in $utils.getNonUniqueValuesFromArray(file_names)" class="file_error" style="margin-bottom: 10px;">
        {{ non_unique }} מופיע יותר מפעם אחת
      </p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Caller from '@/classes/caller.js'
import TextsHelper from '@/classes/texts_helper.js'
import SingleFile from '@/components/SingleFile'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'file',
  props: {
    payload: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    payload: {
      handler(){
        this.show_checkboxes = this.payload.show_checkboxes
      },
      deep: true
    }
  },
  data () {
    return {
      is_loading: true,
      caller: new Caller(),
      texts_helper: new TextsHelper(),
      files: [],
      show_checkboxes: this.payload.show_checkboxes == undefined ? true : this.payload.show_checkboxes,
      rejected_files: [],
      selected_files: {},
      show_reasons_for_errors: false,
    }
  },
  computed: {
    file_names(){
      return [...this.files].map(file => file.name.split('.')[0])
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.is_loading = true
      this.files = []
      this.selected_files = {}
      this.$network_utils.getFiles({ resource_type: this.payload.resource_type, resource_id: this.payload.resource_id }).then(response => {
        this.is_loading = false
        this.files = response
        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i]
          this.selected_files[file.name] = {
            name: file.name,
            is_checked: false
          }
        }
        this.$emit('input', this.files)
        this.emitSelectedFiles()
      })
    },
    uncheckAllFiles(){
      for(let name in this.selected_files){
        this.selected_files[name].is_checked = false
      }
    },
    uploadFile () {
      this.createModal({ 
        designator: 'upload-file-modal', 
        component_name: 'UploadFileForm',
        resource_type: this.payload.resource_type,
        resource_id: this.payload.resource_id, 
        modal_title: 'העלאת קבצים', 
        refresh: this.init
      })
    },
    getCheckedFiles () {
      if(!this.show_checkboxes){
        return []
      }
      let checked_files = []
      for (let name in this.selected_files) {
        if (!this.selected_files[name].is_checked) {
          continue
        }
        checked_files.push(name)
      }
      return checked_files
    },
    setFileChecked(file_name, is_checked){
      this.selected_files[file_name].is_checked = is_checked
      this.$forceUpdate()
      this.emitSelectedFiles()
    },
    emitSelectedFiles(){
      this.$emit('selected_files', this.getCheckedFiles())
    },
    ...mapMutations('modals', ['createModal'])
  },
  components: {
    SingleFile,
    Checkbox
  }
}
</script>